import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(async (method, url, data, opts = {}) => {
    const token = await getToken();
    const res = await axios({ method, url: `${API}${url}`, data, headers: { Authorization: `Bearer ${token}` }, ...opts });
    return res.data;
  }, [getToken]);
}

const MeContext = createContext({ me: null, loading: true });

export function MeProvider({ children }) {
  const api = useApi();
  const { isLoaded, isSignedIn, userId } = useAuth();
  const [me, setMe] = useState(null);
  const [failedFor, setFailedFor] = useState(null);

  useEffect(() => {
    if (!isLoaded || !isSignedIn) { setMe(null); return; }
    api("get", "/me").then(setMe).catch(() => setFailedFor(userId));
  }, [isLoaded, isSignedIn, userId, api]);

  const loading = !isLoaded || (isSignedIn && me?.user_id !== userId && failedFor !== userId);

  return <MeContext.Provider value={{ me, loading }}>{children}</MeContext.Provider>;
}

export const useMe = () => useContext(MeContext);

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" }) : "-");
export const fmtDur = (s) => `${Math.floor((s || 0) / 60)}m ${String((s || 0) % 60).padStart(2, "0")}s`;

export const OFFICER_IMG = "https://images.pexels.com/photos/28446956/pexels-photo-28446956.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const HERO_IMG = "https://images.unsplash.com/photo-1573076978602-a16914734d61?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800";
export const AUTH_IMG = "https://images.pexels.com/photos/30782813/pexels-photo-30782813.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
